<template>
  <v-container max-width="100%" style="margin-top: 2%">

    <v-container class="toolbar__container">
      <v-row>
        <v-toolbar-title style="color: #4a4a4a; margin: 10px 5px 10px 10px">
          {{ $t('dashboardPassengers.title') }}
        </v-toolbar-title>
      </v-row>
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="4" md="3">
            <v-autocomplete v-model="idLinhaSelected" :items="linhas" item-text="cod_linha" item-value="id_linha"
              clearable multiple solo :label="$t('dashboardPassengers.line')" @change="onLinhaChanged"
              :disabled="isLinhaDisabled"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-autocomplete v-model="idVeiculoSelected" :items="veiculosSelect" item-text="numero_ordem"
              item-value="id_veiculo" clearable multiple solo :label="$t('dashboardPassengers.vehicle')"
              @change="onVeiculoChanged"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="5" md="3">
            <v-datetime-picker :label="$t('dashboardPassengers.startDate')" v-model="date"
              :time-picker-props="timeProps" :text-field-props="textFieldProps" :date-picker-props="dtiProps"
              time-format="HH:mm:ss" date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-on="on" v-bind="attrs" fab color="primary" small dark @click="populaDashboard">
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('dashboardPassengers.reload') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

      <merus-data-table
        :headers="headersWithProperties"
        :items="passageiros"
        class="elevation-7"
        locale="pt"
        :sort-by="sortBy"
        :loading="loading"
        :loading-text="$t('dashboardPassengers.loadingPassengers')"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;"
        @update:displayedItems="displayedItemsForExport = $event"
    >
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="title"
                :token="token"
                :items="displayedItemsForExport !== null ? displayedItemsForExport : passageiros"
                csv-title="passageirostemporeal"
                :pdf-title="$t('dashboardPassengers.realTimePassengers')"
                :pdf-headers="headers"
                :pdf-subtitle="pdfsubtitle"
                pdf-filename="passageirostemporeal"
                hide-search
            />
        </template>

        <template v-slot:item.total="{ item }">
            <MediumItem :value="item.total" :medium="item.media_total"></MediumItem>
        </template>
        
    </merus-data-table>

  </v-container>
</template>

  <style>
    .toolbar__container {
      height: fit-content;
      background-color: white;
      border-radius: 10px;
      box-shadow: 0px 5px 5px grey;
      padding: 20px 15px 20px 15px
    }
  </style>
  
  <script>
  import apiController from "@/utils/apiController";
  import EventBus from "@/utils/eventBus";
  import DateUtils from "../utils/dateutils";
  import MediumItem from "./MediumItem.vue";
  import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
  import MerusDataTable from './Tables/MerusDataTable.vue';
  
  export default {
    components: {
    MediumItem,
    CadastroToolbar,
    MerusDataTable,
  },
  data: () => ({
    search: "",
    user: null,
    token: null,
    mensagemAutorizacaoDialog: "",
    displayedItemsForExport: null,
    autorizacaoDialog: false,
    showConfirmButton: true,
    formValidado: false,
    loading: false,
    config: null,
    date: null,
    dti: null,
    dtf: null,
    idLinhaSelected: [],
    linhas: [],
    recursos: [],
    empresasPermitidas: [],
    veiculos: [],
    veiculosSelect: [],
    idVeiculoSelected: [],
    isLinhaDisabled: false,
    timeout: null,
    passageiros: [],
    timeProps: {
      useSeconds: true,
    },
  }),
  computed: {
    pdfsubtitle() {
      return "";
    },
    title() {
      return this.passageiros.length > 0 && this.passageiros[0].id_veiculo ?
        this.$t('dashboardPassengers.vehicles') :
        this.$t('dashboardPassengers.lines');
    },
    sortBy() {
      return this.passageiros.length > 0 && this.passageiros[0].id_veiculo ? "numero_ordem" : "nome_linha";
    },
    headersBase() {
      return [
        { text: this.$t('dashboardPassengers.headers.lastTicketing'), value: "ultima_bilhetagem", align: "center" },
        { text: this.$t('dashboardPassengers.headers.payers'), value: "pagantes", align: "center" },
        { text: this.$t('dashboardPassengers.headers.vt'), value: "vts", align: "center" },
        { text: this.$t('dashboardPassengers.headers.freebies'), value: "gratuidades", align: "center" },
        { text: this.$t('dashboardPassengers.headers.total'), value: "total", align: "center" }];
    },
    headers() {
      return this.passageiros.length > 0 && this.passageiros[0].id_veiculo ? [
        { text: this.$t('dashboardPassengers.headers.vehicle'), value: "numero_ordem", align: "center" },
        ...this.headersBase
      ] : [
        { text: this.$t('dashboardPassengers.headers.line'), value: "nome_linha", align: "center" },
        ...this.headersBase
        ];
      },
      headersWithProperties() {
        return this.headers.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
      dtiProps() {
        return {
          max: new Date().toISOString().substring(0,10)
        }
      },
      textFieldProps() {
        return {
          prependInnerIcon: "mdi-calendar",
          rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
        }
      },
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {},
    methods: {
      initialize() {
        this.populaRecursos();
      },
      populaRecursos() {
        if (this.user.is_superadmin === 1) {
          apiController.request(apiController.endpoints.getallRecursos, {
            silent: true,
            onSuccess: (response) => {
              this.recursos = response.data;
              this.populaEmpresasPermitidas();
              this.populaLinhas();
              this.populaVeiculos();
            },
            onError: (e) => {
              console.log("Response : " + e.message);
              if (e.message == "Request failed with status code 401") {
                EventBus.$emit('show-error', { error: e });
              }
            },
          });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          silent: true,
          onSuccess: (response) => {
            this.recursos = response.data;
            this.populaEmpresasPermitidas();
            this.populaLinhas();
            this.populaVeiculos();
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    populaEmpresasPermitidas() {
      this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
        return rec.id_empresa
      });
    },
    populaConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        silent: true,
        onSuccess: (response) => {
          this.config = response.data[0];
          this.date = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao)[0];
          this.populaDashboard();
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    populaDashboard() {
      this.loading = true;
      this.dtf = DateUtils.getDateSQLFormatted(new Date());
      this.dti = DateUtils.getDateSQLFormatted(this.date);

      this.populaDadosTotais();
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => this.populaDashboard(), 60000);
    },
    populaDadosTotais() {
      if (this.idVeiculoSelected.length > 0) {
        let temp = {
          idveiculos: this.idVeiculoSelected,
          dti: this.dti,
          dtf: this.dtf
        }

        apiController.request(apiController.endpoints.getBilhetagenstotaisdatacarros, {
          data: temp,
          silent: true,
          onSuccess: (response) => {
            this.passageiros = response.data;
            this.loading = false;
          },
          onError: (e) => {
            this.loading = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                this.$t('system.messages.accessDenied');
              this.autorizacaoDialog = true;
            }
          },
        });
      } else {
        let temp = {
          idlinhas: this.idLinhaSelected.length > 0 ? this.idLinhaSelected : this.linhas.map((l) => l.id_linha),
          dti: this.dti,
          dtf: this.dtf
        }

        apiController.request(apiController.endpoints.getBilhetagenstotaisdatalinhas, {
          data: temp,
          silent: true,
          onSuccess: (response) => {
            this.passageiros = response.data;
            this.loading = false;
          },
          onError: (e) => {
            this.loading = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                this.$t('system.messages.accessDenied');
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        silent: true,
        onSuccess: (response) => {
          this.linhas = response.data;
          this.populaConfig();
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        silent: true,
        onSuccess: (response) => {
          this.veiculos = response.data;
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    populaVeiculosSelect() {
      if (this.idLinhaSelected.length > 0) {
        this.veiculosSelect = this.veiculos.filter((v) => {
          return v.id_linha_guia ? this.idLinhaSelected.includes(v.id_linha_guia) : this.idLinhaSelected.includes(v.id_linha_validador);
        });
      } else {
        this.veiculosSelect = this.veiculos;
      }
    },
    onLinhaChanged() {
      this.idVeiculoSelected = [];
      this.populaVeiculosSelect();
    },
    onVeiculoChanged() {
      if (this.idVeiculoSelected.length > 0) {
        this.isLinhaDisabled = true;
      } else {
        this.isLinhaDisabled = false;
      }
    },
  },
};
</script>